/**
 * Shared utility functions
 */

/**
 * Get initials from a name string
 * @param name - Full name string
 * @returns Initials string (e.g., "John Doe" -> "JD", "John" -> "J")
 */
export const getInitials = (name: string): string => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name[0].toUpperCase();
};
